"use client";

import { Box, Grid } from "@mui/material";

import { UserBase } from "@/types/user";

import { useLookup } from "@/context/lookup";

import { getLookupAlert } from "@/components/alerts/global";
import LoginButton from "@/components/loginButton";
import LookupButton from "@/components/lookup/button";
import LookupForm from "@/components/lookup/form";

export default function LookupId() {
  const { errors, getUserId, idSuccess, lookupUser, setErrors, setLookupUser } =
    useLookup();

  return !idSuccess ? (
    <Box mt={2}>
      {!idSuccess && getLookupAlert()}
      <LookupForm<UserBase>
        entity={lookupUser}
        errors={errors}
        set={setLookupUser}
        setErrors={setErrors}
        title="Find My User ID and Username"
      />
      <Grid container justifyContent="flex-end">
        <Grid display="flex" justifyContent="flex-end !important">
          <LookupButton<UserBase>
            entity={lookupUser}
            errors={errors}
            onClick={getUserId}
            tooltipSuffix="to send your username and id"
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <LoginButton />
  );
}
